









import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class LocaleChanger extends Vue {
  private setLocale(locale: string) {
    this.$i18n.locale = locale;
  }
  private isActive(locale: string) {
    return this.$i18n.locale === locale;
  }
}
